import { Flex } from 'antd'

import { SubBrandsStyled } from './styles'

const SubBrands = () => {
  return (
    <SubBrandsStyled>
      <h2 className="title">Principales clientes que construyen con EQUIP</h2>
      <Flex className="grid-images" gap={30}>
        {Array.from({ length: 14 }, (_, index) => index).map((idx: number) => (
          <Flex key={idx} align={'center'}>
            <img src={`/images/brands/im${idx}.svg`} alt={`Brand ${idx}`} height="67" width="134" />
          </Flex>
        ))}
      </Flex>
    </SubBrandsStyled>
  )
}

export default SubBrands
